export default __webpack_public_path__ + "static/media/icon_paquetes_selectos_on.7b653bee.svg";